/**
 * @author simon
 * @Description: 路由
 */
import React from 'react';
import Loadable from 'react-loadable';
import LoadingComponent from '@comp/LoadingComponent';

import NotFound from '@views/NotFound';
import Home from '@views/Home';
import DoctorList from '@views/DoctorList';
import Doctor from '@views/Doctor';
import CommentStart from '@views/Comment/start';
import CommentIndex from '@views/Comment/index';
// import CommentIndex from '@views/Comment/index old2';
import CommentQues from '@views/Comment/question';
import CommentSuc from '@views/Comment/suc';
import PatientIndex from '@views/Patient/index';
import PatientAdd from '@views/Patient/add';
import PatientEdit from '@views/Patient/edit';
import DealDetail from '@views/DealDetail/index';
import DealDetailCoupon from '@views/DealDetailCoupon/index';
import QuestionnaireCoupons from '@views/QuestionnaireCoupons/index';

// 懒加载路由: 独立访问的路由可以直接懒加载
const AsyncComponent = loader =>
  Loadable({
    loader, // 加载promise来加载组件
    loading: LoadingComponent, // 当加载进行中或者错误时加载的组件
    delay: 500, // 加载loading组件之前的延迟，防止闪屏
  });
/** 使用:
 *   webpackChunkName（代码分割后的代码块名）
 *   添加webpackPrefetch：（未来可能需要的资源）
 *   这将导致将<link rel="prefetch" href="home.js">其附加在页面的开头
 *   这将指示浏览器在空闲时间预取home.js文件
 *   不配置预加载和预取提取则按需加载
 */
// AsyncComponent(()=>import(/* webpackChunkName: "home" */ /* webpackPrefetch: true */ './home'))

const routes = [
  {
    path: '/',
    exact: true,
    component: Home,
  },
  {
    path: '/QuestionnaireCoupons',
    exact: true,
    component: QuestionnaireCoupons,
  },
  {
    path: '/doctorList',
    exact: true,
    component: DoctorList,
  },
  {
    path: '/doctor/:id',
    exact: true,
    component: Doctor,
  },
  {
    path: '/activity/:id',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "activity" */ /* webpackPrefetch: true */ '@views/Activity')
    ),
  },
  {
    path: '/icbc/enter',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "activity" */ /* webpackPrefetch: true */ '@views/ICBCVit')
    ),
  },
  {
    path: '/icbc/result',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "activity" */ /* webpackPrefetch: true */ '@views/ICBCVit/Result.jsx')
    ),
  },
  {
    path: '/physiqueTest', //9种体质测评
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "physiqueTest" */ /* webpackPrefetch: true */ '@views/PhysiqueTest')
    ),
  },
  {
    path: '/recipeProgress', //取药进度
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "RecipeProgress" */ /* webpackPrefetch: true */ '@views/RecipeProgress')
    ),
  },
  {
    path: '/comment/start',
    exact: true,
    component: CommentStart,
  },
  {
    path: '/comment/index',
    exact: true,
    component: CommentIndex,
  },
  {
    path: '/comment/ques',
    exact: true,
    component: CommentQues,
  },
  {
    path: '/comment/suc',
    exact: true,
    component: CommentSuc,
  },
  {
    path: '/comment/detail',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "CommentDetail" */ /* webpackPrefetch: true */ '@views/Comment/detail/index')
    ),
  },
  {
    path: '/comment/result',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "CommentResult" */ /* webpackPrefetch: true */ '@views/Comment/result/index')
    ),
  },
  {
    path: '/patient/list/:tag',
    exact: true,
    component: PatientIndex,
  },
  {
    path: '/patient/add',
    exact: true,
    cache: true,
    component: PatientAdd,
  },
  {
    path: '/patient/edit',
    exact: true,
    cache: true,
    component: PatientEdit,
  },
  {
    path: '/deal/:id',
    exact: true,
    component: DealDetail,
  },
  {
    path: '/dealCoupon',
    exact: true,
    component: DealDetailCoupon,
  },
  {
    path: '/coupon/choose', //选择优惠券
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "RecipeProgress" */ /* webpackPrefetch: true */ '@views/CouponChoose')
    ),
  },
  {
    path: '/buyun/list',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "BuYunList" */ /* webpackPrefetch: true */ '@views/BuYunList')
    ),
  },
  {
    path: '/mianyi/',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "BuYunList" */ /* webpackPrefetch: true */ '@views/MianYi')
    ),
  },
  {
    path: '/take', //取号/缴费一体入口
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "take" */ /* webpackPrefetch: true */ '@views/Take/index')
    ),
  },
  {
    path: '/pingan/index',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "pingan-index" */ /* webpackPrefetch: true */ '@views/Pingan/index')
    ),
  },
  {
    path: '/pingan/order',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "pingan-order" */ /* webpackPrefetch: true */ '@views/Pingan/order')
    ),
  },
  {
    path: '/pingan/deal',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "pingan-deal" */ /* webpackPrefetch: true */ '@views/Pingan/deal')
    ),
  },
  {
    path: '/suixing',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "pingan-deal" */ /* webpackPrefetch: true */ '@views/Suixing/index')
    ),
  },
  {
    path: '/member',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "Member" */ /* webpackPrefetch: true */ '@views/MemberNew/index')
    ),
  },
  {
    path: '/memberend',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "MemberPayEnd" */ /* webpackPrefetch: true */ '@views/MemberPayEnd/index')
    ),
  },
  {
    path: '/memberCenter',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberCenter" */ /* webpackPrefetch: true */ '@views/MemberCenterNew/index')
    ),
  },
  {
    path: '/memberRefuel',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberCenter" */ /* webpackPrefetch: true */ '@views/MemberRefuel/index')
    ),
  },
  {
    path: '/refuleList',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "refuleList" */ /* webpackPrefetch: true */ '@views/RefuleList/index')
    ),
  },
  {
    path: '/tongxin',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "MemberTongXin" */ /* webpackPrefetch: true */ '@views/MemberTongXin/index')
    ),
  },
  {
    path: '/memberRights',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberRights" */ /* webpackPrefetch: true */ '@views/MemberRights/index')
    ),
  },
  {
    path: '/memberUpgrade',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberUpgrade" */ /* webpackPrefetch: true */ '@views/MemberUpgrade/index')
    ),
  },
  {
    path: '/memberHealth',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberHealth" */ /* webpackPrefetch: true */ '@views/MemberHealth/index')
    ),
  },
  {
    path: '/patientSelectList',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "patientSelectList" */ /* webpackPrefetch: true */ '@views/PatientSelectList/index')
    ),
  },
  {
    path: '/memberBind',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "memberBind" */ /* webpackPrefetch: true */ '@views/MemberBind/index')
    ),
  },
  {
    path: '/highMember',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "highMember" */ /* webpackPrefetch: true */ '@views/HighMember/index')
    ),
  },
  {
    path: '/highMemberCenter',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "highMemberCenter" */ /* webpackPrefetch: true */ '@views/HighMemberCenter/index')
    ),
  },
  {
    path: '/highMemberExpert',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "highMemberExpert" */ /* webpackPrefetch: true */ '@views/HighMemberExpert/index')
    ),
  },
  {
    path: '/onlineMember',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "onlineMember" */ /* webpackPrefetch: true */ '@views/OnlineMember/index')
    ),
  },
  {
    path: '/giveMember',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "giveMember" */ /* webpackPrefetch: true */ '@views/GiveMember/index')
    ),
  },
  {
    path: '/priorityExpert',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "priorityExpert" */ /* webpackPrefetch: true */ '@views/priorityExpert/index')
    ),
  },
  {
    // 患者唤醒
    path: '/awakenUser',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "awakenUser" */ /* webpackPrefetch: true */ '@views/AwakenUser/index')
    ),
  },
  {
    // 老用户
    path: '/oldUser',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "oldUser" */ /* webpackPrefetch: true */ '@views/OldUser/index')
    ),
  },
  {
    // 老用户领券
    path: '/oldUserCoupon',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: "oldUser" */ /* webpackPrefetch: true */ '@views/OldUserCoupon/index')
    ),
  },
  {
    //上海抗疫
    path: '/ky',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/KangYiPost')),
  },
  {
    //抗疫海报生成
    path: '/post_ky',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/Post')),
  },
  {
    //三伏贴海报生成
    path: '/post_sft',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/Post_sft')),
  },
  {
    //三伏贴海报生成
    path: '/sft',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/SanFuTie')),
  },
  {
    //新冠治疗
    path: '/xgzl',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/XinGuanZhiLiao')),
  },
  {
    //新冠康复义诊
    path: '/xgyz',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/YiZhen')),
  },
  {
    //互联网问诊单
    path: '/online_inquiry',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/OnlineMedicalInquiry')),
  },
  {
    path: '/test',
    component: AsyncComponent(() => import(/* webpackChunkName: "test" */ '@views/Test')),
  },
  {
    path: '/address/add',
    component: AsyncComponent(() => import(/* webpackChunkName: "address/add" */ '@views/Address/Add/index')),
  },
  {
    path: '/address/editor',
    component: AsyncComponent(() => import(/* webpackChunkName: "address/editor" */ '@views/Address/Editor/index')),
  },
  {
    path: '/address/choose',
    component: AsyncComponent(() => import(/* webpackChunkName: "address/choose" */ '@views/Address/List/index')),
  },
  {
    path: '/address/list',
    component: AsyncComponent(() => import(/* webpackChunkName: "address/list" */ '@views/Address/List/index')),
  },
  {
    path: '/zgt',
    component: AsyncComponent(() => import(/* webpackChunkName: "address/list" */ '@views/ZGT/index')),
  },
  {
    path: '/moxibustion',
    component: AsyncComponent(() => import(/* webpackChunkName: "moxibustion" */ '@views/Moxibustion/index')),
  },
  {
    path: '/eveningClinic',
    component: AsyncComponent(() => import(/* webpackChunkName: "EveningClinic" */ '@views/EveningClinic/index')),
  },
  {
    path: '/subvisit',
    component: AsyncComponent(() => import(/* webpackChunkName: "subvisit" */ '@views/SubVisit/index')),
  },
  {
    path: '/subvisits/regist',
    component: AsyncComponent(() => import(/* webpackChunkName: "subvisitRegist" */ '@views/SubVisit/regist/index')),
  },
  {
    path: '/subvisits/followup',
    component: AsyncComponent(() => import(/* webpackChunkName: "subvisitFollowup" */ '@views/SubVisit/followup/index')),
  },
  {
    path: '/subvisits/result',
    component: AsyncComponent(() => import(/* webpackChunkName: "subvisitResult" */ '@views/SubVisit/result/index')),
  },
  {
    path: '/hfl',
    component: AsyncComponent(() => import(/* webpackChunkName: "pinganHaoFuLi" */ '@views/PinganHaoFuLi/index')),
  },
  {
    path: '/opn',
    component: AsyncComponent(() => import(/* webpackChunkName: "OldPushNew" */ '@views/OldPushNew/index')),
  },
  {
    path: '/39tie',
    component: AsyncComponent(() => import(/* webpackChunkName: "SanjiuTie" */ '@views/SanJiuTie/index')),
  },
  {
    path: '/doctorgroup',
    component: AsyncComponent(() => import(/* webpackChunkName: "doctorgroup" */ '@views/DoctorGroup/index')),
  },
  {
    path: '/groupAgreement',
    component: AsyncComponent(() => import(/* webpackChunkName: "DoctorGroupAgreement" */ '@views/DoctorGroupAgreement/index')),
  },
  {
    path: '/recordUpload',
    component: AsyncComponent(() => import(/* webpackChunkName: "RecordUpload" */ '@views/RecordUpload/index')),
  },
  {
    path: '/recordUploads/result',
    component: AsyncComponent(() => import(/* webpackChunkName: "recordUploadResult" */ '@views/RecordUpload/result/index')),
  },
  {
    path: '/omo/activity',
    component: AsyncComponent(() => import(/* webpackChunkName: "OMOActivity" */ '@views/OMOActivity/index')),
  },
  {
    path: '/questionnaire/doctor',
    component: AsyncComponent(() => import(/* webpackChunkName: "QuestionnaireDoctor" */ '@views/Questionnaire/doctor/index')),
  },
  {
    path: '/questionnaire/user',
    component: AsyncComponent(() => import(/* webpackChunkName: "QuestionnaireUser" */ '@views/Questionnaire/patient/index')),
  },
  {
    path: '/questionnaire/result',
    component: AsyncComponent(() => import(/* webpackChunkName: "QuestionnaireResult" */ '@views/Questionnaire/result/index')),
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default routes;
